exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".type-label[data-v-568d9fc5]{color:var(--wf-primary);display:block;font-weight:400;font-size:1em;text-transform:uppercase}.group-title-wrapper[data-v-568d9fc5]{width:100%}h1[data-v-568d9fc5]{font-size:22px}h1.edit-d-title[data-v-568d9fc5]:after{background:transparent;right:-40px}textarea.title-field[data-v-568d9fc5]{font-size:22px}", ""]);

// exports
